<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Mail Taslağı Oluştur</h4>
              <p class="card-category">Aşağıdaki form ile bir mail taslağı oluşturun, tek seferde birden fazla kişiye
                gönderin.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Kod Ismi" placeholder="Daha sonra aradığınızda kolay bulmanız için..."
                    v-model="payload.title">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Mail Başlığı" placeholder="Mail kutusuna bu başlık ile düşecektir."
                    v-model="payload.header">
                  </base-input>
                </div>
              </div>


              <div class="row">
                <div class="col-md-4">
                  <label>Katalog Maili Mi?</label>
                  <base-checkbox type="text" label="Host" placeholder="Host" v-model="payload.isCatalog">
                  </base-checkbox>
                </div>
              </div>

              <div v-if="payload.isCatalog == true" class="row">
                <div class="col-md-4">
                  <div class="text-center">
                    <button class="btn btn-warning btn-fill float-right" type="button" @click="getCatalog">
                      Katalog Çek
                    </button>
                  </div>
                </div>
              </div>




              <div v-if="payload.isCatalog == true" class="row">
                <label>Katalog</label>
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th scope="col">Resim</th>
                      <th scope="col">Marka</th>
                      <th scope="col">Başlık</th>
                      <th scope="col">Model</th>
                      <th scope="col">Özellikler</th>
                      <th scope="col">Sil</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item of payload.catalog">
                      <td>
                        <div><button @click="up(item)">Yukarı</button></div>
                        <br>
                        <br>
                        <div><button @click="down(item)">Aşağı</button></div>
                      </td>
                      <th class="img"><img :src="item.images.find(x => x.isPrimary == true).url"></th>
                      <td>{{ item.brand }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.model }}</td>
                      <td>
                        <ul>
                          <li v-for="itemSpec of item.attributes">
                            <b>{{ itemSpec.key }}:</b> {{ itemSpec.value }}
                          </li>
                        </ul>
                      </td>
                      <td><button @click="deleteItem(item)" class="btn btn-fill btn-danger">Sil</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="payload.isCatalog === false">
                <label>Mail İçeriği</label>
                <textarea v-model="payload.content" class="form-control" rows="10"
                  style="font-family: monospace;"></textarea>
              </div>


              <div class="clearfix"></div>

              <div class="row p-3">
                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewFromMail">
                    Oluştur
                  </button>
                </div>
              </div>







              <div class="clearfix"></div>
            </form>


          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        isCatalog: false,
        catalog: []
      },
    }
  },
  mounted() {
  },
  methods: {
    createNewFromMail() {
      CollectionService.postWidthAuth('mailtemplate', this.payload).then((res) => {
        if (res.success == true) {
          this.$router.push(`/admin/mailtemplates`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getCatalog() {
      let q = { isActive: true, status: 'active' };
      let p = {};
      let o = { skip: 0, limit: 100, sort: { createdAt: -1 } }
      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`


      CollectionService.getCollection('item', query).then((res) => {
        this.payload.catalog = res.items;
        this.notifyVue('bottom', 'right', 'success', 'Katalog çekildi, ' + this.payload.catalog.length)
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    deleteItem(item) {
      this.payload.catalog = this.payload.catalog.filter(x => x._id != item._id);
      this.notifyVue('bottom', 'right', 'warning', "Ürün taslaktan silindi.");
    },
    up(item) {
      console.log({ item });
      var index = this.payload.catalog.findIndex(x => x._id == item._id);
      if (index == 0) return;

      var newCatalog = JSON.parse(JSON.stringify(this.payload.catalog));

      var temp = this.payload.catalog[index - 1];

      newCatalog[index - 1] = item;
      newCatalog[index] = temp;

      this.payload.catalog = newCatalog;
    },
    down(item) {
      var index = this.payload.catalog.findIndex(x => x._id == item._id);
      if (index == this.payload.catalog.length - 1) return;
      var newCatalog = JSON.parse(JSON.stringify(this.payload.catalog));


      var temp = this.payload.catalog[index + 1];

      newCatalog[index + 1] = item;
      newCatalog[index] = temp;

      this.payload.catalog = newCatalog;
    },
  }
}
</script>
<style>
img {
  width: 200px;
  height: 200 px;
}
</style>